import {useFormState} from 'react-final-form'
import {useNavigate} from 'react-router-dom'

import BaseButton from '../../../../../Components/Common/Buttons/BaseButton'

const ActionButtons = ({isSaving, disabled}) => {
  const navigate = useNavigate()
  const {submitting} = useFormState()

  const handleBackClick = () => {
    navigate('/articles')
  }

  return (
    <div className="buttons-wrap">
      <BaseButton
        type="secondary"
        height="small"
        text="Back"
        onClick={handleBackClick}
      />
      <BaseButton
        height="small"
        text="Save"
        htmlType="submit"
        disabled={submitting || disabled}
        loading={isSaving}
      />
    </div>
  )
}

export default ActionButtons
